<template lang="pug">
  server-data(
    ref="list"
    v-bind="$attrs"
    v-slot="{ serverData, loading, pagination }"
  )
    data-wrapper(
      :loading="loading"
      :skeleton-items-count="skeletonItemsCount"
      :has-items="!!serverData.length"
      :skeleton-type="skeletonType"
      :noDataText="noDataText"
      :colsProps="colsProps"
    )
      template(#no-data)
        slot(name="no-data")
      template(#default)
        slot(v-bind="{ serverData, loading, pagination }")
      template(#pagination)
        div(
          v-if="pagination.pages >= pagination.page"
          v-intersect="onIntersect"
        )
</template>
<script>
export default {
  props: {
    colsProps: {
      type: Object,
      default: () => ({
        xl: 3, md: 4, sm: 6, cols: 12,
      }),
    },
    skeletonItemsCount: {
      type: [String, Number],
      default: 6,
    },
    noDataText: {
      type: String,
      default: 'Данный отсутствуют',
    },
    skeletonType: {
      type: String,
      required: true,
    },
  },
  methods: {
    init() {
      this.$refs.list.init();
    },
    loadMoreItems() {
      this.$refs.loadMoreItems();
    },
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.$refs.list.loadMoreItems();
      }
    },
  },
};
</script>
